import React, { Component } from 'react';
import WhatsAppButton from '../../WhatsAppButton.jsx';
import menus from '../menus';

class Contact extends Component {
    state = {
        isDisabled: false, // To track the button's disabled state
        timer: 0, // Countdown timer
    };

    handleFormSubmit = async (e) => {
        e.preventDefault(); // Prevent default form behavior

        const name = e.target.name.value;
        const email = e.target.email.value;
        const message = e.target.message.value;

        const formData = { name, email, message };

        this.setState({ isDisabled: true, timer: 15 }); // Disable button and start countdown

        try {
            const response = await fetch('/.netlify/functions/contact', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(formData),
            });

            const result = await response.json();

            if (response.ok) {
                window.location.href = "/thank-you.html";
            } else {
                console.error('Error al enviar el formulario:', result.message);
            }
        } catch (error) {
            console.error('Error en la conexión con el servidor:', error);
        } finally {
            // Countdown timer to enable the button again after 15 seconds
            const countdown = setInterval(() => {
                this.setState((prevState) => {
                    if (prevState.timer <= 1) {
                        clearInterval(countdown);
                        return { isDisabled: false, timer: 0 }; // Re-enable button
                    }
                    return { timer: prevState.timer - 1 };
                });
            }, 1000);
        }
    };

    render() {
        const { isDisabled, timer } = this.state;

        return (
            <section className="section-padding contact bg-white" id="contact">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-lg-8">
                            <div className="section-heading center-heading text-center mb-60">
                                <h3 className="heading-title">Contact with the author</h3>
                                <h5>neuralnetadaptivecontrol@gmail.com</h5>
                            </div>
                        </div>
                    </div>
                    <div className="row justify-content-center">
                        <div className="col-lg-10 col-sm-12 col-md-12">
                            <form
                                className="contact__form form-row contact-form"
                                method="post"
                                onSubmit={this.handleFormSubmit}
                            >
                                <div className="row">
                                    <div className="col-12">
                                        <div className="alert alert-success contact__msg" style={{ display: 'none' }} role="alert">
                                            Your message was sent successfully.
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
                {/* 👇 Botón flotante de WhatsApp */}
                <div style={{ position: 'fixed', bottom: '0.5rem', right: '0.05rem', zIndex: 50 }}>
                    <WhatsAppButton />
                </div>
            </section>
        );
    }
}

export default Contact;
